<template>
  <payment-link-layout
    v-if="paymentLink && options && downPaymentSelected"
    :hideSecurityWarning="false"
    :isLoading="loading"
  >
    <template v-slot:content>
      <step-progress-bar
        class="mt-24"
        stepTitle="parcelamento"
        :stepNumber="2"
        :stepSize="stepSize"
      />

      <p v-if="options && !retailerRetentionType"
        class="mt-24 pt-24 body-semi-bold gray-900 mb-12">
        Escolha um valor de entrada
      </p>
      <DownPaymentList
        id="down-payment-list"
        v-if="options && !retailerRetentionType"
        :indexSelected="downPaymentIndexSelected"
        @downPaymentChange="onDownPaymentSelected"
        :downPaymentOptions="options"
      />

      <p class="mt-24 body-semi-bold gray-900 mb-4">
        Quantidade de parcelas
      </p>

      <InstallmentSelect
        id="installment-select"
        ref="installment-select"
        :indexSelected="installmentIndexSelected"
        v-if="downPaymentSelected"
        :installments="downPaymentSelected.options[dueDateIndexSelected].installmentOptions"
        @installmentSelect="onInstallmentSelected"
        :loading="installmentValueSkeleton"
      />
      <p v-if="missingFields" class="missing-fields">
        Escolha a quantidade de parcelas
      </p>

      <p class="calendar-title" v-if="downPaymentSelected.hasGracePeriod">
        Vencimento da primeira parcela
      </p>
      <div class="warning-box"  v-if="downPaymentSelected.hasGracePeriod">
      <PaymentDateOptions
        :dateOptions="dateOptions"
        @dueDateSelect="onDueDateSelect"
      />
      </div>

      <option-summary
        v-if="downPaymentSelected"
        class="option-summary-box"
        :class="{'without-ccb-text': !installmentIndexSelected}"
        :downPaymentValue="downPaymentSelected.downPaymentValue"
        :totalAmount="installmentSelected && installmentSelected.totalAmount"
        :installmentAmount="installmentSelected && installmentSelected.numberOfInstallments"
        :installmentValue="installmentSelected && installmentSelected.paymentInstallments"
        :downPaymentPercentage="downPaymentSelected.downPaymentPercentage"
        :interestRatePM="installmentSelected && installmentSelected.interestRatePM"
        :cetPA="installmentSelected && installmentSelected.cetPA"
        :loadingInstallments="installmentValueSkeleton"
        :loadingSummary="summarySkeleton"
        :loadingDownPayment="downPaymentValueSkeleton"
      />
    </template>

    <template v-slot:footer>
      <round-button
        color="primary"
        @click="handleAuthorizeCheckout"
        content="Continuar"
      />
    </template>
  </payment-link-layout>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import DownPaymentList from '@/components/common/DownPaymentList.vue';
import InstallmentSelect from '@/components/common/InstallmentSelect.vue';
import PaymentLinkLayout from '../layout/PaymentLinkLayout.vue';
import StepProgressBar from '../components/StepProgressBar.vue';
import OptionSummary from '../components/credit/OptionSummary.vue';
import RoundButton from '../components/RoundButton.vue';
import PaymentDateOptions from '../../../components/checkout/PaymentDateOptions.vue';

export default {
  name: 'PaymentLinkSelectOptions',
  components: {
    DownPaymentList,
    InstallmentSelect,
    PaymentLinkLayout,
    StepProgressBar,
    OptionSummary,
    RoundButton,
    PaymentDateOptions,
  },
  data: () => ({
    missingFields: false,
  }),
  computed: {
    ...mapState('paymentLink', [
      'options',
      'paymentLink',
      'summarySkeleton',
      'downPaymentValueSkeleton',
      'installmentValueSkeleton',
      'downPaymentIndexSelected',
      'installmentIndexSelected',
      'downPaymentSelected',
      'dueDateIndexSelected',
      'installmentSelected',
      'nextRoute',
      'stepSize',
      'loading',
      'retailerRetentionType',
      'extraQueryRoute',
      'ccbUrl',
    ]),
    ...mapGetters('paymentLink', [
      'dateOptions',
    ]),
  },
  methods: {
    ...mapActions('paymentLink', [
      'getOptions',
      'setLoading',
      'setDownPaymentIndex',
      'setInstallmentIndex',
      'authorizeCheckout',
      'setDueDateIndex',
    ]),
    onDueDateSelect(index) {
      this.setDueDateIndex(index);

      // If installments is selected, should update current state.
      this.setInstallmentIndex({ index: this.installmentIndexSelected });
    },
    onDownPaymentSelected(index) {
      this.setDownPaymentIndex({ index });

      // If installments is selected, should update current state.
      this.setInstallmentIndex({ index: this.installmentIndexSelected });
    },
    onInstallmentSelected(index) {
      if (this.missingFields) this.missingFields = false;
      this.setInstallmentIndex({ index });
    },
    async handleAuthorizeCheckout() {
      if (!this.installmentSelected) {
        this.missingFields = true;
        return;
      }

      this.setLoading({ loading: true });

      await this.authorizeCheckout();

      await this.$router.replace({
        name: this.nextRoute,
        query: {
          ...this.$route.query,
          ...this.extraQueryRoute,
        },
      });

      this.setLoading({ loading: false });
    },
  },
  async mounted() {
    if (!this.paymentLink) return;

    this.setLoading({ loading: true });
    await this.getOptions();
    this.setLoading({ loading: false });
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../scss/__new-styles.scss';

  .warning-box {
    background-color: $white;
  }
  .calendar-title {
    font-weight: bold;
    font-size: 16px;
    margin: 20px 10px 10px 2px;
  }
  .calendar-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 2px;
  }
  .calendar-day-highlighted {
    background-color: #36A3CA ;
    color: white;
    border-radius: 8px;
    padding: 10px;
    text-align: center;
    width: 48px;
    height: 48px;
  }
  .calendar-day {
    background-color: #F1F5F9;
    border-radius: 8px;
    padding: 10px;
    text-align: center;
    width: 48px;
    height: 48px;
  }
  .calendar-text {
    font-size: 13px;
    font-weight: 600;
  }
  .calendar-number {
    font-size: 18px;
    font-weight: bold;
    padding-bottom: 2px;
  }
  .calender-footer {
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
    color: #64748B;
    margin-top: 12px;
  }

  ::v-deep .installment-select-wrapper {
    width: 100%;
  }

  ::v-deep .installment-select-button {
    width: 100%;
    padding: 12px;
  }

  .missing-fields {
    color: var(--danger-dark);
    margin-top: 4px;
  }

  .option-summary-box {
    @extend .mt-24;

    &.without-ccb-text {
      margin-bottom: 24px;

      @media (min-width: $breakpoint-large) {
        margin-bottom: 20px;
      }
    }
  }

  .ccb-text {
    @extend .small-regular;
    @extend .gray-900;

    margin: 20px 0 24px 0;

    @media (min-width: $breakpoint-large) {
      margin: 12px 0 20px 0;
    }
  }
</style>
